import { createSectionAsync, fetchMyPlanDetailAsync } from "components/features/MyPlanDetails/MyPlanDetails.slice";
import * as React from "react";
import { useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import SectionFormContent from "../SectionFormContent";

type Inputs = {
  Title: string;
  Description: string;
};
interface Props {
  item: any;
  handleDialogClose: () => void;
}

function AddNewSectionForm(props: Props, ref: any) {
  const { item, handleDialogClose } = props;
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<Inputs>();

  const [sectionTitleValue, setSectionTitleValue] = React.useState(String);
  const [sectionDescriptionValue, setSectionDescriptionValue] = React.useState(String);
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const dispatch = useAppDispatch();

  React.useImperativeHandle(ref, () => {
    return {
      submitForm: () => {
        const onsubmit = handleSubmit(async (data) => {
          handleDialogClose();
          const props = {
            planId: selectedMyPlanDetail?.id,
            name: sectionTitleValue,
            summary: sectionDescriptionValue
          };
          await dispatch(createSectionAsync(props));
          dispatch(fetchMyPlanDetailAsync({ id: selectedMyPlanDetail?.id, includePropertyInfo: true }));
        });
        onsubmit();
      }
    };
  });

  return (
    <SectionFormContent
      setSectionTitleValue={setSectionTitleValue}
      setSectionDescriptionValue={setSectionDescriptionValue}
      item={item}
      register={register}
      errors={errors}
    />
  );
}

export default React.forwardRef(AddNewSectionForm);
